import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { createDisposable, useEffectDisposableOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { DialogActions, DialogContent, TextField, Autocomplete, DialogTitle, Dialog, Button } from "@mui/material";
import { uncurry2, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { append, iterate, empty, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { API_Tickets_CustomerTicketsWithOrders, API_Customer_OrdersWith, API_Tickets_Order } from "../Shared/Urls.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Tickets_TicketMeta_$reflection, Order, Customer, Company, GenericResponse_$reflection, Order_$reflection } from "../Shared/ApiDataTypes.js";
import { toArray, unwrap, map, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, Result_DefaultValue, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty as empty_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { array_type, obj_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { loadingIndicatorSmall } from "../ViewHelpers.js";
import Check from "@mui/icons-material/Check";
import { ctx as ctx_1 } from "../Context.js";
import { Result_catch, Orders_OrderStatus } from "../Shared/Shared.js";
import { minValue, toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Boolean.js";
import { toString as toString_2 } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Components_Filterbar_Z27381C84 } from "../Components/Filterbar.js";
import { ComponentsModule_Chip_Level, Components_Chip_51BC9844 } from "../Components/Chip.js";
import { Orders_Table_1967F6FE } from "../Orders/Table.js";

function UpdateTicketButton(updateTicketButtonInputProps) {
    let elems;
    const onUpdate = updateTicketButtonInputProps.onUpdate;
    const ticketIdOpt = updateTicketButtonInputProps.ticketIdOpt;
    const order = updateTicketButtonInputProps.order;
    const locale = updateTicketButtonInputProps.locale;
    const patternInput = reactApi.useState(false);
    const setUpdating = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setComplete = patternInput_1[1];
    const complete = patternInput_1[0];
    useEffectDisposableOnce(() => createDisposable(() => {
        setComplete(false);
    }));
    return MuiHelpers_createElement(Button, [["variant", "contained"], ["color", "primary"], ["size", "small"], ["disabled", ticketIdOpt == null], ["style", createObj(toList(delay(() => (complete ? singleton(["backgroundColor", "#008000"]) : empty()))))], ["onClick", (_arg_2) => {
        let properties_2;
        setUpdating(true);
        if (ticketIdOpt != null) {
            const ticketId = ticketIdOpt | 0;
            const url = API_Tickets_Order(ticketId);
            let pr_2;
            const data = some(Auto_generateBoxedEncoder_437914C6(Order_$reflection(), undefined, undefined, undefined)(order));
            const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
            const data_1 = data;
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_2 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2.then((res) => {
                if (res.tag === 0) {
                    setComplete(true);
                    const pr_1 = new Promise(resolve => setTimeout(resolve, 250));
                    pr_1.then(() => {
                        onUpdate(ticketId);
                    });
                }
                else {
                    console.error(some("Failed updating ticket with new order"), res.fields[0]);
                    onUpdate(undefined);
                }
                setUpdating(false);
            });
        }
        else {
            console.error(some("Cannot call update without selecting a ticket"));
        }
    }], (elems = toList(delay(() => {
        let props_1;
        return patternInput[0] ? singleton(loadingIndicatorSmall()) : (complete ? singleton((props_1 = {}, react.createElement(Check, props_1))) : singleton(locale.t("Save")));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

function AssignTicketDialog(assignTicketDialogInputProps) {
    let elements_2, children, elems, children_1;
    const onClose = assignTicketDialogInputProps.onClose;
    const tickets = assignTicketDialogInputProps.tickets;
    const orderOpt = assignTicketDialogInputProps.orderOpt;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const initial = new Order(-1, -1, undefined, new Orders_OrderStatus(0, []), toString_1(minValue()), "", new Company(-1, "", "", "", []), undefined, new Customer(-1, "", []));
    patternInput = reactApi.useState(initial);
    const order = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setTicketId = patternInput_1[1];
    useEffectWithDeps(() => {
        iterate(patternInput[1], toArray(orderOpt));
        return createDisposable(() => {
            const pr = new Promise(resolve => setTimeout(resolve, 100));
            pr.then(() => {
                setTicketId(undefined);
            });
        });
    }, [orderOpt]);
    return MuiHelpers_createElement(Dialog, [["open", orderOpt != null], ["onClose", (delegateArg, delegateArg_1) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", order.Desc]]), (children = singleton_1(createElement("div", createObj(ofArray([["style", {
        paddingTop: 5 + "px",
        width: 550 + "px",
    }], (elems = [MuiHelpers_createElement(Autocomplete, [["fullWidth", true], ["isOptionEqualToValue", (option_1) => ((value_15) => (option_1.Id === value_15.Id))], ["options", Array.from(tickets)], ["getOptionLabel", (ticket) => toText(printf("#%i - %s"))(ticket.Id)(ticket.ShortDesc)], ["noOptionsText", ctx.Locale.t("Customer.NoAvailTickets")], ["onChange", (_arg_2, v, _arg_1_1) => {
        setTicketId(map((ticket_1) => ticket_1.Id, v));
    }], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => singleton(["label", "Ticket"]))))))]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["variant", "contained"], ["color", "secondary"], ["size", "small"], ["onClick", (_arg_3) => {
        onClose(undefined);
    }], ["children", ctx.Locale.t("Cancel")]]), createElement(UpdateTicketButton, {
        locale: ctx.Locale,
        order: order,
        ticketIdOpt: unwrap(patternInput_1[0]),
        onUpdate: (updatedTicketIdOpt) => {
            onClose(updatedTicketIdOpt);
        },
    })]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

/**
 * List of orders that are not assigned
 */
export function List(customerInfo) {
    let elems_1, elems;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoadingOrders = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const setOrders = patternInput_1[1];
    const orders = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setSelectedOrder = patternInput_2[1];
    const selectedOrder = patternInput_2[0];
    const patternInput_3 = reactApi.useState(true);
    const patternInput_4 = reactApi.useState([]);
    const tickets = patternInput_4[0];
    const setTickets = patternInput_4[1];
    let patternInput_5;
    const initial_5 = Result_DefaultValue(false, Result_catch(parse, localStorage.getItem("kundeweb-orders-with-ticket")));
    patternInput_5 = reactApi.useState(initial_5);
    const includeOrdersWithTicket = patternInput_5[0];
    let patternInput_6;
    const initial_6 = Result_DefaultValue(false, Result_catch(parse, localStorage.getItem("kundeweb-orders-include-closed")));
    patternInput_6 = reactApi.useState(initial_6);
    const includeClosedOrders = patternInput_6[0];
    const ordersOpt = (patternInput[0] ? true : patternInput_3[0]) ? undefined : orders;
    useEffectWithDeps(() => {
        let properties_2;
        let active = true;
        const url = API_Customer_OrdersWith([["with-ticket", toString_2(includeOrdersWithTicket)], ["any-status", toString_2(includeClosedOrders)]], customerInfo.Id);
        if (active) {
            setLoadingOrders(true);
        }
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Order_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Order_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_3) => Result_MapError(testRedirect, result_3)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                if (active) {
                    setOrders(res.fields[0]);
                }
            }
            else {
                console.error(some("Could not fetch customer orders:"), res.fields[0]);
            }
            setLoadingOrders(false);
        });
        return createDisposable(() => {
            active = false;
        });
    }, [customerInfo.Id, includeOrdersWithTicket, includeClosedOrders]);
    useEffectWithDeps(() => {
        let properties_6;
        let active_1 = true;
        const url_4 = API_Tickets_CustomerTicketsWithOrders(customerInfo.Id, true, false, false);
        let pr_5;
        let pr_4;
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), undefined, undefined);
        const data_5 = undefined;
        const caseStrategy_10 = undefined;
        const extra_10 = extraCoders;
        try {
            const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url_4, properties_3_1).then((_arg_2) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_3) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_4 = (pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_5 = (pr_4.then((result_5) => Result_MapError(testRedirect, result_5)));
        pr_5.then((res_1) => {
            if (res_1.tag === 0) {
                if (active_1) {
                    setTickets(res_1.fields[0]);
                }
                else {
                    console.warn(some("Fetched tickets for customer"), customerInfo.Name, "but while not active");
                }
            }
            else {
                console.error(some("Failed fetching tickets:"), res_1.fields[0]);
            }
            patternInput_3[1](false);
        });
        return createDisposable(() => {
            active_1 = false;
        });
    }, [customerInfo.Id]);
    const xs_2 = [createElement(AssignTicketDialog, {
        orderOpt: unwrap(selectedOrder),
        tickets: tickets,
        onClose: (updatedTicketIdOpt) => {
            iterate((ticketId) => {
                setTickets(tickets.filter((ticket) => (ticket.Id !== ticketId)));
                iterate((selected) => {
                    setOrders(map_1((order) => {
                        if (order.Id === selected.Id) {
                            return new Order(selected.Id, selected.Number, updatedTicketIdOpt, selected.Status, selected.Date, selected.Desc, selected.Company, selected.Department, selected.Customer);
                        }
                        else {
                            return order;
                        }
                    }, orders));
                }, toArray(selectedOrder));
            }, toArray(updatedTicketIdOpt));
            setSelectedOrder(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: 100 + "%",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
    }], (elems = [createElement(Components_Filterbar_Z27381C84, {
        children: [createElement(Components_Chip_51BC9844, {
            key: "with-ticket-filter-chip",
            $key: "with-ticket-filter-chip",
            primary: "Tilknyttet ticket",
            enabled: includeOrdersWithTicket,
            onClick: () => {
                const value_4 = !includeOrdersWithTicket;
                localStorage.setItem("kundeweb-orders-with-ticket", toString_2(value_4));
                patternInput_5[1](value_4);
            },
            colorLevel: new ComponentsModule_Chip_Level(5, []),
        }), createElement(Components_Chip_51BC9844, {
            key: "include-closed-ticket-filter-chip",
            $key: "include-closed-ticket-filter-chip",
            primary: ctx.Locale.t("Closed"),
            enabled: includeClosedOrders,
            onClick: () => {
                const value_5 = !includeClosedOrders;
                localStorage.setItem("kundeweb-orders-include-closed", toString_2(value_5));
                patternInput_6[1](value_5);
            },
            colorLevel: new ComponentsModule_Chip_Level(5, []),
        })],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Orders_Table_1967F6FE, {
        orders: unwrap(ordersOpt),
        rowsPerPage: 10,
        onTicketAssign: (arg_2) => {
            setSelectedOrder(arg_2);
        },
        includeWithTickets: includeOrdersWithTicket,
        includeClosedOrders: includeClosedOrders,
    })];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

